import React, { Fragment, useContext, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Dropdown } from "semantic-ui-react";
import { BasicContext } from "../../App";
import { postMethod } from "../../requests";

const ClassTypesDropdown = (props) => {
    const { onChange, value, multiple, classN, req, id, disabled, label } = props;
    const { t } = useTranslation();
    const { checkServerData } = useContext(BasicContext);
    const [list, setList] = useState(null);
    const [loading, setLoading] = useState(true);

    const getClassTypes = async () => {
        const res = await postMethod("/get-classes-types");
        if (checkServerData(res)) {
            const list = [],
                typeList = res.data.types;
            typeList.forEach((e, i) => {
                list.push({
                    key: i,
                    value: e.class_type_code,
                    text: e.class_type_name,
                });
            });
            setList(list);
        }
    };

    useEffect(() => {
        if (list) setLoading(false);
        // eslint-disable-next-line
    }, [list]);

    useEffect(() => {
        getClassTypes();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <Form.Group className={classN ? classN : "mb-3"}>
                <Form.Label>
                    {label ? label : t(`classes.classesType${multiple ? "s" : ""}`)} {req && <span className="text-danger">*</span>}
                </Form.Label>
                {loading ? (
                    <p>{t("loadingData")}</p>
                ) : (
                    <Dropdown
                        placeholder={multiple ? t("chooseMany") : t("choose")}
                        fluid
                        multiple={multiple}
                        selection
                        options={list}
                        onChange={(e, data) => onChange(data.value)}
                        value={value}
                        id={id}
                        disabled={disabled}
                    />
                )}
            </Form.Group>
        </Fragment>
    );
};

export default ClassTypesDropdown;
